import { useCallback } from 'react';
import { useRightPanelPinnedWidth } from './RightPanel';

const useGetLayoutBaseWidth = () => {
  const rightPanelPinnedWidth = useRightPanelPinnedWidth();
  return useCallback(
    () => window.innerWidth - (rightPanelPinnedWidth ?? 0),
    [rightPanelPinnedWidth],
  );
};

export default useGetLayoutBaseWidth;
